import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import { NAV_LINKS, COMPANY } from "../data/content";

const linkId = (label) => `nav-link-${label.toLowerCase().replace(/\s+/g, "-")}`;

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-white" data-testid="site-header">
      <div className="container-site flex h-20 items-center justify-between gap-6">
        <Link to="/" className="flex shrink-0 items-center" data-testid="nav-logo-link" aria-label={COMPANY.name}>
          <img
            src="/assets/vaskion-logo.png"
            alt={COMPANY.name}
            className="h-12 w-auto"
            width="138"
            height="48"
          />
        </Link>

        <nav className="hidden items-center gap-1 xl:flex" aria-label="Primary" data-testid="nav-desktop">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              data-testid={linkId(link.label)}
              className={({ isActive }) =>
                `px-3 py-2 font-heading text-sm font-medium transition-colors duration-200 ${
                  isActive
                    ? "text-brand-red"
                    : "text-brand-graphite hover:text-brand-red"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <Link
            to="/contact?intent=consultation"
            className="btn-primary ml-3 !px-5 !py-2.5"
            data-testid="nav-schedule-consultation-button"
          >
            Schedule a Consultation
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        </nav>

        <button
          type="button"
          className="inline-flex items-center justify-center p-2 text-brand-graphite transition-colors duration-200 hover:text-brand-red xl:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-label={open ? "Close menu" : "Open menu"}
          data-testid="nav-mobile-menu-toggle"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav
          className="border-t border-border bg-white xl:hidden"
          aria-label="Mobile"
          data-testid="nav-mobile-menu"
        >
          <div className="container-site flex flex-col py-4">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                data-testid={`mobile-${linkId(link.label)}`}
                className={({ isActive }) =>
                  `border-b border-border py-3.5 font-heading text-base font-medium transition-colors duration-200 last:border-0 ${
                    isActive ? "text-brand-red" : "text-brand-graphite hover:text-brand-red"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              to="/contact?intent=consultation"
              className="btn-primary mt-4"
              data-testid="mobile-nav-schedule-consultation-button"
            >
              Schedule a Consultation
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
};

export default Navbar;
